import { ChecklistVehicle } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

export enum WorkorderChecklistItemType {
  Workorder = 'workorder',
  Diagnostic = 'diagnostic',
}
export interface WorkorderChecklistContextParams {
  checklistItemId: number;
  workorderComplementId?: number;
  workorderId?: number;
  diagnosticId?: number;
  checklistItemType?: WorkorderChecklistItemType;
  boschChecklist?: boolean;
  vehicleSelected?: ChecklistVehicle;
  customerId?: number;
  companyId?: number;
}
